import React from "react";

function NavbarAuth() {
    return (
        <>
        </>
    );
}

export default NavbarAuth;